import { defineComponent as _defineComponent } from 'vue'
import * as Plot from '@observablehq/plot'
import { onMounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PlotComponent',
  props: {
    options: null
  },
  setup(__props: any) {

const props = __props as { options: any }


const target = ref<HTMLDivElement>()

const render = () => {
  if (target.value) {
    target.value.innerHTML = ''
    target.value.append(Plot.plot(props.options))
  }
}

onMounted(() => {
  render()
})

watch(
  () => props,
  () => {
    render()
  },
  { deep: true }
)

return { __sfc: true,props, target, render }
}

})